
<style>

#br_main {
  display: block !important;
  padding-left: 315px !important;
  transition: 0.3s ease;
}

#br_logo_img {
  padding-left: 10px;
}

</style>

<template>
  <v-app>
    <sidebar-menu class="br_sidebar_menu" :menu="current_menu"
      :hideToggle="true"
      theme="white-theme"
      width="300px">
      <div id="br_logo" slot="header">
        <img id="br_logo_img" width="68px" height="68px" src="/assets/bison_router_logo.svg">
      </div>
    </sidebar-menu>
    <v-main id="br_main">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

import { SidebarMenu } from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import { set_auth_token_hdr } from './services/api.js';

export default {
  components: {
    SidebarMenu
  },

  data: () => ({
    menu_logged_out: [
      { href: '/about', title: 'About', },
      { href: '/login', title: 'Login', },
    ],
    menu: [
      { href: '/about', title: 'About', },
      {
          title: 'Dashboard',
          child: [
            { href: '/dashboard/ports', title: 'Ports' },
            { href: '/dashboard/vifs', title: 'VIF' },
            { href: '/dashboard/nat_maps', title: 'NAT maps' },
            { href: '/dashboard/vifs/monitoring', title: 'VIF selection' },
          ]
      },
      { href: '/vif', title: 'VIF', },
      { href: '/iface_graph', title: 'Interface graphs', },
      { href: '/vif_ip_addr', title: 'IPv4 addresses', },
      { href: '/vif_ipv6_addr', title: 'IPv6 addresses', },
      {
          title: 'IPv4 routing',
          child: [      
            { href: '/ip_route_table', title: 'IPv4 route tables', },
            { href: '/ipv4_route', title: 'IPv4 routes', },
            { href: '/pbr_rules', title: 'IPv4 PBR rules', },
          ]
      },
      { href: '/ipv6_vif', title: 'IPv6 interfaces', },
      {
          title: 'IPv6 routing',
          child: [      
            { href: '/ipv6_route_table', title: 'IPv6 route tables', },
            { href: '/ipv6_route', title: 'IPv6 routes', },
            { href: '/pbr6_rules', title: 'IPv6 PBR rules', },
          ]
      },
      { href: '/ip_pool', title: 'IP pools', },
      { href: '/ipv6_pool', title: 'IPv6 pools', },
      {
          title: 'Radius',
          child: [      
            { href: '/radius_client', title: 'Radius clients', },
            { href: '/coa', title: 'Radius CoA', },
          ]
      },
      {
          title: 'IPoE',
          child: [
            { href: '/ipoe_settings', title: 'IPoE settings' },
            { href: '/ipoe_ipv4_subsc', title: 'IPoE IPv4 subscribers' },
            { href: '/ipoe_profile', title: 'IPoE profiles' },
            { href: '/ipoe_profile_bindings', title: 'IPoE profile bindings' },
          ]
      },      
      {
          title: 'PPPoE',
          child: [
            { href: '/pppoe_ipv4_subsc', title: 'PPPoE IPv4 subscribers' },
            { href: '/pppoe_ipv6_subsc', title: 'PPPoE IPv6 subscribers' },
            { href: '/pppoe_profile', title: 'PPPoE profiles' },
            { href: '/pppoe_profile_bindings', title: 'PPPoE profile bindings' },
            { href: '/pppoe_settings', title: 'PPPoE settings' },
          ]
      },
      {
          title: 'Prefix maps',
          child: [
            { href: '/prefix_maps', title: 'Prefix maps' },
            { href: '/prefix_map_entries', title: 'Prefix map entries' },
          ]
      },      
      {
          title: 'NAT',
          child: [
            {
              href: '/nat/interface',
              title: 'NAT interfaces'
            },
            {
              href: '/nat/nat_policy',
              title: 'NAT policy'
            },
            {
              href: '/nat/det_nat',
              title: 'Deterministic SNAT44 maps'
            },
            {
              href: '/nat/det_nat/sessions',
              title: 'Deterministic SNAT44 sessions'
            },
            {
              href: '/nat/nat3',
              title: 'SNAT44 maps'
            },
            {
              href: '/nat/nat3/sessions',
              title: 'SNAT44 sessions'
            },
            {
              href: '/nat/nat11',
              title: 'NAT44 1:1 maps'
            },
            {
              href: '/nat/nat11/sessions',
              title: 'NAT44 1:1 sessions'
            },
            {
              href: '/nat/nat11/trans_rules',
              title: 'NAT44 1:1 translation rules'
            },
            {
              href: '/nel',
              title: 'NEL: NAT events logging'
            },
          ]
      },
      { href: '/sysctl', title: 'Sysctl variables', },
      { href: '/config_save', title: 'Save configuration', },
      { href: '/logout', title: 'Logout', },
    ]    
  }),

  methods: {
    main_menu_on_click(goto_path) {
      this.$router.push({ path: goto_path });
    }
  },

  computed: { 
    current_menu() {
      return this.$store.state.is_logged_in ? this.menu : this.menu_logged_out;
    }
  },

  created() {
    this.$store.dispatch('reload_login_state');
  },
};

</script>
